import script from "./sjInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./sjInfoList.vue?vue&type=script&setup=true&lang=js"

import "./sjInfoList.vue?vue&type=style&index=0&id=08a1285e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a1285e"]])

export default __exports__